import React from "react";

const CompanyLogoAndName = () => {
  return (
    <div>
      <div className="flex flex-col items-center  space-x-3 pb-2 rtl:space-x-reverse">
        <img
          src="/LQLogoSm1.png"
          alt="Logo"
          width={36}
          height={36}
          //   onClick={reloadPage}
          id="cubeLogoInNavbar"
        />
      </div>
    </div>
  );
};

export default CompanyLogoAndName;
